//the connect utility helps us map the state to react component's props
import { connect } from 'react-redux';

import { hashHistory } from 'react-router';

import 'whatwg-fetch';

const queryString = require('query-string');

console.log(queryString);

//import testData from "./test";

import Complete from './Complete.jsx';

import DaysOfTheWeek from 'utils/days';

import cloneDeep from 'lodash/cloneDeep';

import assign from 'lodash/assign';

import getSavedApp from 'utils/load-application';

const mapStateToProps = state => {
  let form = state.form['employment-application'];
  let errors = form ? assign({}, form.syncErrors) : {};

  return {
    config: state.config,
    values: state.form['employment-application'] ? state.form['employment-application'].values : {},
    errors: errors,
    initialValues: getSavedApp()
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: values => {
      window.test = cloneDeep(values);

      //format values
      let booleans = [
        'eighteenOrOver',
        'authorized',
        'convicted',
        'availableDays',
        'availableEvenings',
        'availableHolidays',
        'availableWeekends'
      ];

      booleans.forEach(field => {
        values[field] = values[field] == 'true';
      });

      //format days available
      if (values.daysAvailable) {
        values.daysAvailable = values.daysAvailable
          .map((avail, index) => {
            if (avail) {
              avail.day = DaysOfTheWeek[index];
            }
            return avail;
          })
          .filter(avail => avail);
      }

      //format employmentHistory
      if (values.employmentHistory && values.employmentHistory.length > 0) {
        values.employmentHistory.map(history => {
          history.canContactEmployer = history.canContactEmployer === 'true';
          //remove end date if not set
          if (!history.endDate) {
            delete history.endDate;
          }
        });
      }

      values.houseId = queryString.parse(location.search).theatre;

      return fetch(window.location.origin + '/submit', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(values)
      })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then(response => response.json())
        .then(payload => {
          console.log(payload);
          // clean out local storage
          localStorage.removeItem('employment-application');
          // redirect to completed page
          window.location.href = 'submitted';
        })
        .catch(error => {
          console.log(error);
          error.response.text().then(message => {
            alert(`An error has occured: ${error}.  Details: ${message}`);
          });
        });
    },
    goToPrevious: () => hashHistory.push('employment-desired')
  };
};

const CompleteContainer = connect(mapStateToProps, mapDispatchToProps)(Complete);

export default CompleteContainer;
